import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { LoaderGenericComponent } from './loader-generic.component';

@Injectable({
  providedIn: 'root',
})
export class LoaderGenericService {
  private spinnerRef: OverlayRef;

  constructor(private overlay: Overlay) {
    this.spinnerRef = this.cdkSpinnerCreate();
  }

  private cdkSpinnerCreate() {
    return this.overlay.create({
      hasBackdrop: true,
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    });
  }

  public showSpinner() {
    if (!this.spinnerRef) {
      this.cdkSpinnerCreate();
    }
    if (!this.spinnerRef.hasAttached()) {
      const spinnerOverlayPortal = new ComponentPortal(LoaderGenericComponent);
      this.spinnerRef.attach(spinnerOverlayPortal);
    }
  }

  public stopSpinner() {
    // console.log('Method: stopSpinner - Detach', this.spinnerRef);
    if (!!this.spinnerRef) {
      this.spinnerRef.detach();
    }
  }
}
